module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "uFghY3E9oG7VYoqgE67JhN2"
    }
  }, [_c('p', {
    staticClass: "Title ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Saint Sebastian")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Part of the Queering Consent series")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("An excerpt from the forthcoming book ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Experience Points")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("N.A.Melamed")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("This edition © Microcosm Publishing, 2021")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("eBook ISBN 9781648411465")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("This is Microcosm #719")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("For a catalog, write or visit:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Microcosm Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("2752 N Williams Ave.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Portland, OR 97227")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("www.Microcosm.Pub")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Did you know that you can buy our books directly from us at sliding scale rates? Support a small, independent publisher and pay less than Amazon’s price at ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("www.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Microcosm.Pub")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "uNnCb8XHBOLawAdaJEZJ2o4"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/logostamp-black.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e0873a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stsebastianepub.vue
// module id = 57
// module chunks = 0